import React from 'react'
import { Modal, message } from 'antd'

/** Normalized result of a card action, regardless of which endpoint served it. */
export interface CardActionOutcome {
  successCount: number
  failedCount: number
  /** One "<card label>: reason" line per failed item, for the modal. */
  failureLines: string[]
}

/**
 * Reports a card action's result. Shared by the "Associated VCNs" panel and Card
 * Mode: `cards/terminate` is partial-success by design — one bad card does not
 * fail the request — so a bare success toast would hide the failures, and both
 * callers have to report them the same way or the same response means two
 * different things depending on where the admin clicked.
 *
 * Callers build `failureLines` because a useful label differs by surface: the
 * panel names a card by "vcn number · member", Card Mode by insured person and
 * last 4.
 */
export function showCardActionOutcome(
  actionLabel: string,
  outcome: CardActionOutcome
): void {
  if (outcome.failedCount === 0) {
    void message.success(
      `${actionLabel}: ${outcome.successCount} card(s) processed successfully.`
    )
    return
  }
  Modal.warning({
    title: `${actionLabel} — partial failure`,
    content: (
      <div>
        <p>
          {outcome.successCount} succeeded, {outcome.failedCount} failed:
        </p>
        <pre style={{ maxHeight: 200, overflow: 'auto', fontSize: 12 }}>
          {outcome.failureLines.join('\n')}
        </pre>
      </div>
    ),
    width: 520,
  })
}
